import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { LoggedUserService } from "./services/common/logged-user.service";
import { RoleNames } from "./utils/role-names";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private loggedUserService: LoggedUserService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAdministratorOnly = next.data.isAdminOnly;
    let userRole = this.loggedUserService.getLoggedUserRole();
    console.log("userRole", userRole);
    if (isAdministratorOnly && userRole == RoleNames.ERT_USER) {
      this.router.navigate(["no-access"]);
      return false;
    } else {
      return true;
    }
  }
}
